import Vue from 'vue'
import VueRouter from 'vue-router'
import CreditRequest from '../views/CreditRequest.vue'
import SubmitRequest from '../views/SubmitRequest.vue'
import CreditInfo from '../views/CreditInfo.vue'
import notFound from '../components/404Page/notFound.vue'
import { publicPath } from '../../vue.config'

const DocumentsSign = () => import('../views/DocumentsSign.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/:id(\\w{32})',
    name: 'CreditRequest',
    component: CreditRequest
  },
  {
    path: '/submit-request',
    name: 'SubmitRequest',
    component: SubmitRequest
  },
  {
    path: '/documents-sign/:id',
    name: 'DocumentsSign',
    component: DocumentsSign
  },
  {
    path: '/',
    name: 'CreditInfo',
    component: CreditInfo
  },
  {
    path: '/overdraft',
    name: 'CreditInfo',
    component: CreditInfo
  },
  {
    path: '/comfortable-credit',
    name: 'comfortableCredit',
    component: CreditInfo
  },
  {
    path: '*',
    name: 'notFound',
    component: notFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: publicPath,
  routes
})

export default router
